import { orderTracking, orderAttachment } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getOrderTrackingDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderTracking.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderTrackingLogs(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderTracking.base}${id}/logs/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderTrackingItems(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderTracking.base}${id}/items/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  cancelOrder(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${orderTracking.base}${id}/cancel_order/`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  rescheduleOrder(data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${orderTracking.base}reschedule_order/`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDeliveryLocationForOrder(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderTracking.base}${id}/change_delivery_location/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateDeliveryLocationForOrder(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${orderTracking.base}${id}/change_delivery_location/`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderAttachmentPODDownload(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderAttachment.base}generate_e_pod/`, {
          params: params,
          headers: { "Content-type": "application/pdf" },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  customerFeedBack(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${orderTracking.base}${payload.id}/feedback/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
